import PropTypes from "prop-types"
import React, { useState, useCallback, useRef, useEffect, useMemo } from "react"
import {
  Container,
  Button
} from "reactstrap"

import { useNavigate } from "react-router-dom"
import Select from "react-select"
//i18n
import { withTranslation } from "react-i18next"
//class
import chevleft from "assets/images/services-icon/chev-left.png"
import axios from "axios"
import { BASE_URL} from "../../global"
//popup

import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import _ from "lodash";
import Loader from "react-spinner-loader"
import { groupItemsByFolderActivityType, sortLibraryBySubjectName } from "./library-utility"
import {
  getAuthToken,
  shouldBlockWorkApi,
  getActAsTutorName,
  isAdminMode,
  TUTOR_ADMIN_VIEW_CHANGED,
} from "../../common/auth/tutor-admin-auth"

const LibraryShare = props => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [loadingTutor, setTutorLoading] = useState(false)
  const [dataTableData, setDataTableData] = useState([])
  const [OptionTutor, setOptionTutor] = useState([])
  const [selectedTutors, setSelectedTutors] = useState([])

  const [checked, setChecked] = useState([]);
  const [expanded, setExpanded] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [adminViewName, setAdminViewName] = useState(getActAsTutorName() || "")

  const fetchData = async () => {
    try {
      if (shouldBlockWorkApi()) {
        setDataTableData([])
        setLoading(false)
        return
      }

      const token = getAuthToken()
      if (token && token != "" && token != null) {
         setLoading(true)
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`
        const response = await axios.post(
          BASE_URL + "mylibrary/getAllMyLibrary",
          {}
        )
        if(response){
          const myLibItems = response.data || [];
          const sortedMyLibItems = sortLibraryBySubjectName(myLibItems);


          setDataTableData(sortedMyLibItems)
          setLoading(false)
        }else{
          setLoading(false)
        }
        
      } else {
        navigate("/login")
        setLoading(false)
      } /*  */
      // setAllData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error)
      setLoading(false)
    }
  }

   const fetchTutorData = async () => {
    try {
      if (getAuthToken() && getAuthToken() != "" && getAuthToken() != null) {
        setTutorLoading(true);
        axios.defaults.headers.common["Authorization"] = `Bearer ${getAuthToken()}`
        const response = await axios.post(
          BASE_URL + "mylibrary/getAllTutorByCenter",
          {}
        )
        if(response){
         const tutorOptions = response.data.map(option => ({
          value: option.pk_tut_key,
          label: option.tutor_name,
        }))
        setOptionTutor(tutorOptions)
        setTutorLoading(false)
      }
      } else {
        navigate("/login")
        setTutorLoading(false)
      } /*  */
      // setAllData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error)
      setTutorLoading(false)
    }
  }

  const fetchTutorExistingData = async (fk_tut_key) => {
    try {
      if (getAuthToken() && getAuthToken() != "" && getAuthToken() != null) {
        setTutorLoading(true);
        axios.defaults.headers.common["Authorization"] = `Bearer ${getAuthToken()}`
        const response = await axios.post(
          BASE_URL + "mylibrary/getTutorExistingActivity",
          {fk_tut_key: fk_tut_key}
        )
        if(response){
          const tutorExistingData = response.data.map(option => option.fk_tutor_library_item_key);
          setChecked(tutorExistingData)
          setTutorLoading(false)
        }else{
          setTutorLoading(false)
        }
      } else {
        navigate("/login")
        setTutorLoading(false)
      } /*  */
      // setAllData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error)
      setTutorLoading(false)
    }
  }

  
  useEffect(() => {
    fetchData();
    fetchTutorData();
  }, []);

  useEffect(() => {
    const handleAdminViewChanged = () => {
      setAdminViewName(getActAsTutorName() || "")
      fetchData()
      fetchTutorData()
    }

    window.addEventListener(TUTOR_ADMIN_VIEW_CHANGED, handleAdminViewChanged)
    return () => {
      window.removeEventListener(TUTOR_ADMIN_VIEW_CHANGED, handleAdminViewChanged)
    }
  }, []);

  useEffect(() => {
    if (selectedTutors.length === 1) {
      fetchTutorExistingData(selectedTutors[0])
    } else if (selectedTutors.length === 0) {
      setChecked([])
    }
  }, [selectedTutors]);

  const optionGroup3 = [
    { label: "Video", value: "1" },
    { label: "Link", value: "3" },
    { label: "Task", value: "4" },
    { label: "Work sheet", value: "5" },
    { label: "File", value: "10" },
  ]
  const activityTypeMap = optionGroup3.reduce((map, item) => {
    map[item.value] = item.label
    return map
  }, {})

  const buildCheckboxTreeNodes = (dataTableData) => {
    return dataTableData
      .filter(item => Array.isArray(item.TutorLibraryItems) && item.TutorLibraryItems.length > 0)
      .map(subjectItem => {

        const _groupItemsByFolderActivityType = groupItemsByFolderActivityType(subjectItem.TutorLibraryItems)
        const foldersGrouped = _groupItemsByFolderActivityType.items;
        const sortedFolderKeys = _groupItemsByFolderActivityType.sortedKeys;

        return {
          value: `subject-${subjectItem.subject_id}`,
          label: subjectItem.subject_name,
          children: sortedFolderKeys.map((folderKey) => {
            const folderData = foldersGrouped[folderKey];
            const groupedItems = folderData.items;
            const sortedActivityKeys = folderData.sortedKeys;

            return {
              value: `folder-${subjectItem.subject_id}-${folderKey}`,
              label: folderData.folder_name,
              children: sortedActivityKeys.map(type => ({
                value: `type-${subjectItem.subject_id}-${folderKey}-${type}`,
                label: activityTypeMap[type] || type,
                children: groupedItems[type].items.map(item => ({
                  value: `${item.pk_tutor_library_item_key || item.name}`, // Ensure unique `value`
                  label: item.name || '-', // or format label with more info
                })),
              })),
            };
          }),
        };
      });
  };

  const [nodesData, setnodesData] = useState([])
  useEffect(() => {
    const treeNodes = buildCheckboxTreeNodes(dataTableData) || [];
    setnodesData(treeNodes);
  }, [dataTableData]);


  const getHighlightText = (text, keyword) => {
    const startIndex = text.indexOf(keyword);
    return startIndex !== -1 ? (
      <span>
        {text.substring(0, startIndex)}
        <span style={{ color: "#2cb664" }}>
          {text.substring(startIndex, startIndex + keyword.length)}
        </span>
        {text.substring(startIndex + keyword.length)}
      </span>
    ) : (
      <span>{text}</span>
    );
  };

  const getAllValuesFromNodes = (nodes) => {
    const values = [];
    for (let n of nodes) {
      values.push(n.value);
      if (n.children) {
        values.push(...getAllValuesFromNodes(n.children));
      }
    }
    return values;
  };

  const keywordFilter = (nodes, keyword) => {
    const newNodes = [];
    for (let n of nodes) {
      const nodeCopy = { ...n };
      if (nodeCopy.children) {
        const filteredChildren = keywordFilter(nodeCopy.children, keyword);
        if (filteredChildren.length > 0) {
          nodeCopy.children = filteredChildren;
        } else if (nodeCopy.label.toLowerCase().includes(keyword.toLowerCase())) {
          nodeCopy.children = [];
        }
        if (
          filteredChildren.length > 0 ||
          nodeCopy.label.toLowerCase().includes(keyword.toLowerCase())
        ) {
          nodeCopy.label = getHighlightText(nodeCopy.label, keyword);
          newNodes.push(nodeCopy);
        }
      } else {
        if (nodeCopy.label.toLowerCase().includes(keyword.toLowerCase())) {
          nodeCopy.label = getHighlightText(nodeCopy.label, keyword);
          newNodes.push(nodeCopy);
        }
      }
    }
    return newNodes;
  };

  const handleSearchChange = useCallback((event) => {
    const value = event.target.value;

    if (keyword.trim() && !value.trim()) {
      //setExpanded([]);
      setKeyword(value);
      return;
    }

    const searched = keywordFilter(_.cloneDeep(nodesData), value);
    const newExpanded = getAllValuesFromNodes(searched);
    setExpanded(newExpanded);
    setKeyword(value);
  }, [keyword]);

  const searchedNodes = useMemo(() => {
    return keyword.trim()
      ? keywordFilter(_.cloneDeep(nodesData), keyword)
      : nodesData;
  }, [keyword, nodesData]);


  // console.log('Checked === ', checked);
  const [isSubmitting, setIsSubmitting] = useState(false)

  const shareLibraryWithTutor = async (fk_to_tutor_key) => {
    const response = await axios.post(BASE_URL + "mylibrary/LibraryActivitiesShared", {
      fk_to_tutor_key,
      library_item: checked,
    })
    return response.data == 1
  }

  const OnSubmitShareData = async () => {
    try {
      if (!getAuthToken()) {
        return
      }

      if (!selectedTutors.length) {
        toast.error("Please select at least one tutor.", { autoClose: 3000 })
        return
      }

      if (!checked.length) {
        toast.error("Please select at least one library activity.", { autoClose: 3000 })
        return
      }

      setIsSubmitting(true)
      axios.defaults.headers.common["Authorization"] = `Bearer ${getAuthToken()}`

      const results = await Promise.all(
        selectedTutors.map(async (tutorKey) => {
          try {
            const success = await shareLibraryWithTutor(tutorKey)
            return { tutorKey, success }
          } catch (error) {
            console.error("Error sharing library with tutor:", tutorKey, error)
            return { tutorKey, success: false }
          }
        })
      )

      const succeeded = results.filter(r => r.success)
      const failed = results.filter(r => !r.success)

      if (succeeded.length === results.length) {
        toast.success(
          `Library activities shared with ${succeeded.length} tutor${succeeded.length > 1 ? "s" : ""}.`,
          {
            autoClose: 2000,
            onClose: () => {
              window.location.reload()
            },
          }
        )
      } else if (succeeded.length > 0) {
        toast.warning(
          `Shared with ${succeeded.length} tutor${succeeded.length > 1 ? "s" : ""}; failed for ${failed.length}.`,
          { autoClose: 4000 }
        )
        setIsSubmitting(false)
      } else {
        toast.error("Unable to share activities. Try again later.", { autoClose: 3000 })
        setIsSubmitting(false)
      }
    } catch (error) {
      console.error("Error sharing library:", error)
      toast.error("Unable to share activities. Try again later.", { autoClose: 3000 })
      setIsSubmitting(false)
    }
  }
  return (
    <React.Fragment>
      <ToastContainer />
      <Loader
        show={loading || loadingTutor}
        type="body"
      // stack="vertical"
      // message="Loading Data"
      />
      <div className="page-content" style={{minHeight: "100vh"}}>
        <Container fluid>
          <div className="page-title-box">
            <div>
              <div className="d-flex align-items-center">
                <div className="short-ic" onClick={() => window.history.back()}>
                  <img className="bc-bg2 mr-30" src={chevleft} />
                </div>

                <div>
                  <h6
                    className="page-title inner-pg-title mb-0"
                    style={{ width: "20vw" }}
                  >
                    {" "}
                    Library Sharing System
                  </h6>
                </div>
              </div>
            </div>
            <div className="custom-pg_header justify-content-start mb-3 align-items-center pdt-15 w-100">
              <div className="filter-child me-3" style={{ minWidth: "280px", maxWidth: "420px" }}>
                <Select
                  isMulti
                  menuPlacement="auto"
                  options={OptionTutor}
                  name="tutors"
                  placeholder="Select tutor(s)..."
                  value={OptionTutor.filter(option =>
                    selectedTutors.some(
                      tutorKey => option.value.toString() === tutorKey.toString()
                    )
                  )}
                  onChange={selectedOptions => {
                    setSelectedTutors(
                      selectedOptions ? selectedOptions.map(option => option.value) : []
                    )
                  }}
                  id="tutors"
                />
              </div>
              <div className="filter-section filter-libary pymts d-flex gap-3 mt-0 me-3">
                <form className="app-search page-search mylibary" style={{width:'280px'}}>
                  <div className="position-relative">
                    <span className="ion ion-ios-search"></span>
                    <input
                      type="text"
                      className="form-control"
                      value={keyword}
                      placeholder={"Search for Activity Name..."}
                      onChange={handleSearchChange}
                      style={{height: '40px'}}
                       //onChange={(event) => handleSearchChange(event.target.value)}
                    />
                  </div>
                </form>
                
              </div>
              <div>
                {selectedTutors.length > 0 ? (
                  <Button
                    type="button"
                    variant="contained"
                    color="danger"
                    disabled={isSubmitting}
                    onClick={OnSubmitShareData}
                  >
                    Share
                  </Button>
                ) : null}
              </div>
            </div>
            
          </div>
          <div><h4>My Library</h4></div>
            {searchedNodes && searchedNodes.length > 0? 
            <CheckboxTree
              nodes={searchedNodes}
              checked={checked}
              expanded={expanded}
              onCheck={(checkedItems) => {
                if (selectedTutors.length > 0) {
                  setChecked(checkedItems)
                } else {
                  toast.error("Please select at least one tutor before choosing activities.", {
                    autoClose: 3000,
                  })
                }
              }}
              onExpand={(expanded) => setExpanded(expanded)}
              expandOnClick
              onClick={(data) => {
                // console.log("on click");
                // console.log(data);
              }}
              showNodeIcon={true}
            />
            :
             <p>No Data</p> }
        </Container>
      </div>
    </React.Fragment>
  )
}

LibraryShare.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(LibraryShare)
